import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showErrorSnackbar, showSuccessSnackbar } from "../../actions/snackbar";
import { deleteAddress } from "../../api/customer";
import { getCustomerAddress } from "../../actions/customer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import useStyles from "./styles";
import { authKey_local_storage_key } from "../../helpers/common";
import MetaTags from "../Common/MetaTags";
import AccountWrapper from "../Account/AccountWrapper";
import UpdateAddressModal from "./UpdateAddressModal";
import NewAddressModal from "./NewAddressModal";

export default function MyAddresses() {
  const classes = useStyles();
  const navigate = useNavigate();
  const addressList = useSelector((state) => state.customers.address);
  const dispatch = useDispatch();
  const token = localStorage.getItem(authKey_local_storage_key);

  const [openUpdateAddressModal, setOpenUpdateAddressModal] = useState(false);
  const [openNewAddressModal, setOpenNewAddressModal] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [deleteData, setDeleteData] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      dispatch(
        showErrorSnackbar("You are not logged out ! Please login to continue"),
      );
      navigate("/");
    }
  }, [token, navigate, dispatch]);

  const updateAddress = (address) => {
    setSelectedAddress(address);
    setSelectedAddressId(address.id);
    setOpenUpdateAddressModal(true);
  };

  const addNewAddress = () => {
    setOpenNewAddressModal(true);
  };

  const confirmDelete = (address) => {
    setDeleteData(address);
  };

  const handleCloseDelete = () => {
    setDeleteData(null);
  };

  const handleDelete = () => {
    if (!deleteData) return;
    setDeleteLoading(true);
    deleteAddress(deleteData, deleteData.id)
      .then(() => {
        dispatch(getCustomerAddress()).then((ack) => {
          dispatch(showSuccessSnackbar("Address deleted successfully!"));
        });
      })
      .catch((_err) => {
        dispatch(showErrorSnackbar("Error occurred, please try again later."));
      })
      .finally(() => {
        setDeleteLoading(false);
        setDeleteData(null);
      });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <AccountWrapper title="My Addresses">
      <div>
        <MetaTags title="My Addresses" description="" keywords=""></MetaTags>

        {selectedAddress && (
          <UpdateAddressModal
            openUpdateAddressModal={openUpdateAddressModal}
            setOpenUpdateAddressModal={setOpenUpdateAddressModal}
            selectedAddressId={selectedAddressId}
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
          />
        )}
        <NewAddressModal
          openNewAddressModal={openNewAddressModal}
          setOpenNewAddressModal={setOpenNewAddressModal}
        />

        <Dialog open={Boolean(deleteData)} onClose={handleCloseDelete}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this address?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDelete}
              color="primary"
              disabled={deleteLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              color="error"
              autoFocus
              disabled={deleteLoading}
            >
              {deleteLoading ? "Deleting..." : "Delete"}
            </Button>
          </DialogActions>
        </Dialog>

        <div className="container">
          <div className={classes.myAddressesSec} style={{ paddingTop: "0" }}>
            {addressList.length > 0 ? (
              <div className={classes.form}>
                <div className="row mr-0 ml-0">
                  {addressList.map((address) => (
                    <div key={address.id} className={`col-12 ${classes.col}`}>
                      <div className={classes.detailRow}>
                        <div className={classes.leftCol}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              marginBottom: "8px",
                            }}
                          >
                            <i
                              className={
                                address.address_type === "home"
                                  ? "fa fa-home"
                                  : "fa fa-building-o"
                              }
                              style={{ fontSize: "16px" }}
                            />
                            <h5 style={{ marginTop: 5 }}>
                              {address.address_name}
                            </h5>
                          </div>
                          <h6>{address.contact_person}</h6>
                          <p>
                            {address.full_address}, {address.state} -{" "}
                            {address.pin_code}
                          </p>
                          <p>Mobile: {address.mobile_number}</p>
                        </div>
                        <div className={classes.rightCol}>
                          {/* <i class="fa-solid fa-buildings"></i> */}
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginTop: "auto",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              onClick={() => updateAddress(address)}
                              className={classes.edit}
                            >
                              <i className="fa fa-edit" />
                            </div>
                            <div
                              onClick={() => confirmDelete(address)}
                              className={classes.edit}
                            >
                              <i className="fa fa-trash" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className={classes.noAddress}>
                <p>
                  You don't have any address here, add a new address to
                  continue.
                </p>
              </div>
            )}

            <div className={classes.addNew}>
              <div
                className={classes.newAddressLink}
                style={{ cursor: "pointer" }}
                onClick={addNewAddress}
              >
                {" "}
                + Add New Address
              </div>
            </div>
          </div>
        </div>
      </div>
    </AccountWrapper>
  );
}
